import { QueryResult } from "@/api/utils/types"
import { BackofficeRestQueries } from "@/api/backofficeRest/queries"
import { AgreementDetails } from "@/api/backofficeRest/generated/model"
import { BackofficeAgreementParser } from "@/models/agreement/agreementBackoffice.parser"
import { IAgreementDetailed } from "@/models/agreement/agreementDetailed.types"
import { useQuery } from "@/api/utils/useQuery"

export interface IAgreementService {
  getForMeterpoint(
    billingAccountId: number | null,
    meterpointIdentifier: string,
  ): QueryResult<IAgreementDetailed[]>
}

class AgreementServiceClass implements IAgreementService {
  getForMeterpoint(
    billingAccountId: number | null,
    meterpointIdentifier: string,
  ): QueryResult<IAgreementDetailed[]> {
    const query =
      BackofficeRestQueries.meterpointAgreements.getMeterPointAgreements(
        billingAccountId ?? 0,
        meterpointIdentifier,
      )

    return useQuery({
      ...query,
      // MeterpointService.getMeterPointAgreements consumes the same endpoint
      // with a different parser; useQuery caches the parsed result by key, so
      // this legacy-domain variant needs its own cache entry.
      queryKey: [...query.queryKey, "agreementDetailed"],
      placeholderData: [],
      useRawResponse: true,
      parserFn: (rawData: AgreementDetails[]) =>
        (rawData ?? []).map((item) => BackofficeAgreementParser.toDomain(item)),
      enabled: !!billingAccountId && !!meterpointIdentifier,
    })
  }
}

export const AgreementService = new AgreementServiceClass()
